import React from "react";

const ProductDetailsSection = ({ products }) => {
    return (
        <section className="product-details-section">
            <div className="container">

                {products.map((product, index) => (
                    <div
                        className={`product-row-modern ${index % 2 === 1 ? "reverse" : ""}`}
                        key={product.id}
                    >
                        <div className="product-image-modern">
                            <img src={product.image} alt={product.name} />
                        </div>

                        <div className="product-content-modern">
                            <span className="product-category-tag">
                                {product.category}
                            </span>

                            <h3>{product.name}</h3>

                            <p className="product-desc">
                                {product.description}
                            </p>

                            <div className="product-specs">
                                <div><strong>Technical:</strong> {product.technical}</div>
                                <div><strong>Formulation:</strong> {product.formulation}</div>
                                <div><strong>Pack Size:</strong> {product.packSize}</div>
                            </div>
                        </div>
                    </div>
                ))}


            </div>
<style>{`
.product-details-section {
  padding: 100px 0;
  background: #f8fdf9;
}

/* ONE PRODUCT BLOCK */
.product-row-modern {
  display: flex;
  align-items: center;
  gap: 60px;
  margin-bottom: 30px;
  padding: 50px;
  border-radius: 26px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(0,0,0,0.08);
}

/* ALTERNATE LAYOUT */
.product-row-modern.reverse {
  flex-direction: row-reverse;
  background: linear-gradient(
    to right,
    #ffffff,
    #f4fdf6
  );
}

/* IMAGE */
.product-image-modern {
  flex: 0 0 38%;
  background: #f4fdf6;
  border-radius: 22px;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image-modern img {
  max-width: 100%;
  max-height: 320px;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.product-row-modern:hover img {
  transform: scale(1.05);
}

/* CONTENT */
.product-content-modern {
  flex: 1;
}

.product-category-tag {
  display: inline-block;
  background: #03612D;
  color: #F4C104;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  margin-bottom: 14px;
}

.product-content-modern h3 {
  font-size: 2.1rem;
  font-weight: 800;
  color: #03612D;
  margin-bottom: 14px;
}

.product-desc {
  font-size: 1.05rem;
  line-height: 1.75;
  color: #444;
  margin-bottom: 22px;
}

/* SPECS */
.product-specs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 30px;
  font-size: 0.95rem;
}

.product-specs strong {
  color: #03612D;
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .product-row-modern,
  .product-row-modern.reverse {
    flex-direction: column;
    padding: 35px;
    gap: 30px;
  }

  .product-specs {
    grid-template-columns: 1fr;
  }
}

`}</style>
        </section>
    );
};

export default ProductDetailsSection;
